import { Injectable, OnDestroy } from '@angular/core';

import { environment } from 'src/environments/environment';
import { LoggingMessageService } from './logging-message.service';

import { UserPreferences } from 'src/app/shared/user-preferences.model';

// **
// Uses SessionStorage for saving user preference data that isn't sensitive/secure in nature
// **
@Injectable({
    providedIn: 'root'
  })
export class StorageService {

    constructor() {
        this.loadUserPreferences();
    }
    private STORE_ID = environment.StorageID;
    private userPreferences: UserPreferences;

    public saveUserPreferences() {
        sessionStorage.setItem(this.STORE_ID, this.userPreferences.ToJSON());
    }

    public setToken(token: string) {
        sessionStorage.setItem(environment.AccessTokenID, token);
    }

    public getPendoUserId(): string {
        const id = sessionStorage.getItem(environment.PendoUserID);
        return id;
    }

    public getUserRole(): string {
        const id = sessionStorage.getItem(environment.TokenUserRole);
        return id;
    }

    public getSelectedHospitalId(): string {
        const id = sessionStorage.getItem(environment.HospitalId);
        return id;
    }

    public getUserHospId(): string {
        const id = sessionStorage.getItem(environment.UserHospId);
        return id;
    }

    public getSelectedHospitalName(): string {
        const name = sessionStorage.getItem(environment.HospitalName);
        return name;
    }

    public getUnitId(): string {
        const id = sessionStorage.getItem(environment.UnitId);
        return id;
    }
    public setUnitId(unitid: string) {
        sessionStorage.setItem(environment.UnitId, unitid);
    }

    public getUserUnitName(): string {
        const name = sessionStorage.getItem(environment.UnitName);
        return name;
    }

    public getIndicatorId(): string {
        const id = sessionStorage.getItem(environment.IndicatorId);
        return id;
    }
    public setIndicatorId(indid: string) {
        sessionStorage.setItem(environment.IndicatorId, indid);
    }

    public getSubscription(): string {
        const sub = sessionStorage.getItem(environment.SubscriptionSelected);
        if ((sub === null) || (sub === undefined)) {
            return '0';
        }
        return sub;
    }
    public setSubscription(sub: string) {
        sessionStorage.setItem(environment.SubscriptionSelected, sub);
    }
    
    public getSubscriptionsAvailable(): string {
        let subs = sessionStorage.getItem(environment.TokenSubscriptionsAvailable);
        subs = (subs === null) ? "" : subs;
        return subs;
    }
    public setSubscriptionsAvailable(s: string) {
        sessionStorage.setItem(environment.TokenSubscriptionsAvailable, s);
    }

    public getIndicatorYear(): number {
        if (this.userPreferences && this.userPreferences.IndicatorYear) {
            return this.userPreferences.IndicatorYear;
        }
        return Number.NaN;
        // const year = this.getCurrentYear();
        // return year;
    }
    public setIndicatorYear(year: number) {
        this.userPreferences.IndicatorYear = year;
    }

    public getIndicatorQtr(): number {
        if (this.userPreferences && this.userPreferences.IndicatorQtr) {
            return this.userPreferences.IndicatorQtr;
        }
        return Number.NaN;
        // const qtr = this.getCurrentQuarter();
        // return qtr;
        // return 1;
    }
    public setIndicatorQtr(qtr: number) {
        this.userPreferences.IndicatorQtr = qtr;
    }

    private loadUserPreferences(): UserPreferences {
        const local: string = sessionStorage.getItem(this.STORE_ID);
        const preferences = new UserPreferences(local);
        this.userPreferences = preferences;
        return preferences;
    }

    // public getCurrentYear(): number {
    //     return moment().year();
    // }

    // public getCurrentQuarter(): number {
    //     return moment().quarter();
    // }

}
